module.exports = __webpack_public_path__ + "img/dawn,_Ivan,_Dalai_Lama_and_Zabe_.734e3285.jpg";